import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types/swagger';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY } from '@/swagger/constants/contents-likes-keys';
import { KEY_POST_CONTENTS_LIKES, API_POST_CONTENTS_LIKES } from '../constants';
import { MOCK_RESPONSE_POST_CONTENTS_LIKES } from '../mocks';

export type RequestPostContentsLikes = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY
>['request']['body'];

export type ResponsePostContentsLikes = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY
>['response']['body'];

export type CallParamsPostContentsLikes = RequestPostContentsLikes & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostContentsLikes = ResponsePostContentsLikes;

type CallErrorPostContentsLikes = {
  message: string;
  code: number;
};

type CallSelectorsPostContentsLikes = unknown;

export const postContentsLikesCall = createGeneralCall<
  CallParamsPostContentsLikes,
  CallResponsePostContentsLikes,
  CallErrorPostContentsLikes,
  CallSelectorsPostContentsLikes
>({
  id: KEY_POST_CONTENTS_LIKES,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_CONTENTS_LIKES(org as unknown as string);
  },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_CONTENTS_LIKES : undefined,
});
